import React from 'react';
import { Link as RouterLink } from 'react-router';

import { Link as RadixLink } from '@radix-ui/themes';
import classNames from 'classnames';

import {
  LinkProps,
  sizeToClassNameMap,
  variantToClassNameMap,
  weightToClassNameMap,
} from './Link.types';

function Link({
  highContrast,
  children,
  to,
  size = '2',
  weight = 'regular',
  variant = 'default',
  className,
  state,
  underline,
  ref,
  ...props
}: LinkProps & { ref?: React.Ref<HTMLAnchorElement> }) {
  const isGhost = variant === 'ghost';

  return (
    <RadixLink
      asChild={!!to}
      color={isGhost ? undefined : 'indigo'}
      underline={underline ?? (isGhost ? 'none' : undefined)}
      ref={ref}
      className={classNames(
        'cursor-pointer',
        sizeToClassNameMap[size],
        weightToClassNameMap[weight],
        isGhost
          ? variantToClassNameMap.ghost
          : highContrast
            ? 'text-custom-12'
            : 'text-indigoA-9',
        className
      )}
      {...props}
    >
      {to ? (
        <RouterLink to={to} state={state}>
          {children}
        </RouterLink>
      ) : (
        children
      )}
    </RadixLink>
  );
}

export { Link };
